import request from '@/plugins/request';
import utils from '@/utils';
import { IBoolResult, IErrorResult } from '@/types/dto';
import { AxiosError, AxiosResponse } from 'axios';

const $url = '/register';
const $urlSendSms = '/register/actions/sendSms';

interface ISendSmsRequest {
  mobile: string;
}

interface ISubmitRequest {
  userName: string,
  password: string,
  mobile: string;
  code: string;
}

export default {
  sendSms(req: ISendSmsRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($urlSendSms, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error, true);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void, failure: (errorMessage: string) => void) {
    utils.loading(true);

    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch((error: AxiosError<IErrorResult>) => {
        const errorMessage = utils.getErrorMessage(error);
        failure(errorMessage);
      });
  },
};
